"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToLongArray = void 0;
exports.longArrayToNumber = longArrayToNumber;
exports.longArrayToNumberBigint = longArrayToNumberBigint;
exports.writeLevelDat = writeLevelDat;
const fs_1 = __importDefault(require("fs"));
const prismarine_nbt_1 = __importDefault(require("prismarine-nbt"));
const util_1 = require("util");
const zlib_1 = __importDefault(require("zlib"));
async function write(nbtData) {
    const data = await prismarine_nbt_1.default.writeUncompressed(nbtData);
    return await (0, util_1.promisify)(zlib_1.default.gzip)(data);
}
function longArrayToNumber(longArray) {
    const [high, low] = longArray;
    return (high << 32) + low;
}
function longArrayToNumberBigint(longArray) {
    const [high, low] = longArray;
    return (BigInt(high) << 32n) + BigInt(low);
}
const numberToLongArray = (num) => {
    if (typeof num === 'number')
        num = BigInt(num);
    const high = Number(num >> 32n);
    const low = Number(num & 0xffffffffn);
    return [high, low];
};
exports.numberToLongArray = numberToLongArray;
async function writeLevelDat(path, value, oldLevelRaw) {
    const nbt = {
        type: 'compound',
        name: '',
        value: {
            Data: {
                type: 'compound',
                value: {
                    ...oldLevelRaw?.value?.Data?.value,
                    GameRules: {
                        type: 'compound',
                        value: {
                            ...oldLevelRaw?.value?.Data?.value.GameRules?.value,
                            ...Object.fromEntries(Object.entries(value.GameRules ?? {}).map(([key, val]) => {
                                return [key, {
                                        type: 'string',
                                        value: val ? 'true' : 'false'
                                    }];
                            })),
                        }
                    },
                    Version: {
                        type: 'compound',
                        value: {
                            Name: {
                                type: 'string',
                                value: value.Version?.Name
                            }
                        }
                    },
                    LevelName: {
                        type: 'string',
                        value: value.LevelName ?? 'prismarine-world'
                    },
                    generatorName: {
                        type: 'string',
                        value: value.generatorName
                    },
                    version: {
                        type: 'int',
                        value: 19133
                    },
                    RandomSeed: {
                        type: 'long',
                        value: value.RandomSeed
                    },
                    allowCommands: {
                        type: 'byte',
                        value: (value.allowCommands ?? true) ? 1 : 0
                    },
                    DayTime: {
                        type: 'long',
                        value: (0, exports.numberToLongArray)(value.time ?? 0)
                    }
                }
            }
        }
    };
    const data = await write(nbt);
    await fs_1.default.promises.writeFile(path, data);
}
